import { DropdownButtonType, List, MenuItemInfo, SingleSelectDropdown } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { AddUserDialogType } from '~src/userManagement/components/AddUsersButton';

export interface AddNewUserDropdownFormProps {
  readonly menuItems: MenuItemInfo[];
  onOptionSelected?: (value: AddUserDialogType) => void;
  currentSelection?: AddUserDialogType;
}

const DefaultDropdownMenuWidth = 370;
const defaultSiteRoleDropdownWidth = DefaultDropdownMenuWidth - CommonStyles.Sizes.DefaultSpace - (2 * CommonStyles.Sizes.TextBoxBorderSize);

export function AddNewUserDropdownForm(props: AddNewUserDropdownFormProps) {

  return <div style={{ display: 'inline-block' }}>
    <SingleSelectDropdown
      className={style({
        width: defaultSiteRoleDropdownWidth,
      })}
      value={props.currentSelection}
      onChange={props.onOptionSelected}
      testId={'identity-pools-picker'}
      list={<List items={props.menuItems} />}
      label={Messages.identityPools_AddUsersDialog_IdentityPools_ActionPickerLabel()}
      type={DropdownButtonType.Outline}
    />
  </div>;
}
